import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommentsService } from '../../services/comments.service';
import { ThreadPostModel } from '../../models/comment-models/thread-post-model';
import { ConfigurationService } from '../../../shared/services/configuration.service';
import { ThreadTopic } from '../../models/comment-models/thread-topic.enum';
import { UserModel } from '../../../core/user-model.model';
import { UserService } from '../../../core/user.service';
import { MessageType } from '../../../core/models/enum/message-type';
import { ApplicationMessage } from '../../../core/models/application-message';
import { CustomMessageService } from '../../../core/message.service';
import { ApplicationMessageSource } from '../../../core/models/application-message-source';
import { Table } from 'primeng/table';
import { LazyLoadEvent } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-thread-view',
  templateUrl: './thread-view.component.html',
  styleUrls: ['./thread-view.component.less'],
  standalone: false,
})
export class ThreadViewComponent implements OnInit {
  @Input()
  public threadId: number;
  @Input()
  public display: boolean;
  @Input()
  public topicId: ThreadTopic;
  @Output()
  public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onDeleteComment: EventEmitter<boolean> = new EventEmitter<boolean>();

  public posts: ThreadPostModel[];
  public totalRecords: number;
  public pageSize: number;

  public ThreadTopicEnum = ThreadTopic;
  public dateFormat: string;

  @ViewChild(Table, { static: true }) tableComponent: Table;

  public currentUser: UserModel;

  constructor(
    private commentsService: CommentsService,
    private config: ConfigurationService,
    private translateService: TranslateService,
    private userService: UserService,
    private messageService: CustomMessageService
  ) {
    this.posts = [];
    this.currentUser = null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['threadId'] && changes['threadId'].currentValue != null) ||
      (changes['display'] &&
        changes['display'].currentValue == true &&
        this.threadId)
    ) {
      this.tableComponent.reset();
    }
  }

  onLoad(event: LazyLoadEvent) {
    if (this.threadId) {
      this.commentsService
        .FilterThreadComments(this.threadId, event.first, event.rows)
        .subscribe((d) => {
          this.totalRecords = d.totalCount;
          this.posts = d.items;
        });
    }
  }

  onCancel() {
    this.onClose.emit(false);
  }

  addComment() {
    this.onClose.emit(true);
  }

  deleteComment(postId: number) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.commentsService.DeleteComment(postId).subscribe((r) => {
        if (r.success) {
          this.showMessage(r.message, MessageType.Success);
          this.tableComponent.reset();
          this.onDeleteComment.emit(r.success);
        } else {
          this.showMessage(r.message, MessageType.Error);
        }
      });
    }
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.pageSize = config.defaultPageSize;
    this.dateFormat = config.dateFormat;
    this.currentUser = this.userService.currentUser;
  }

  private showMessage(message: string, type: MessageType) {
    if (message != null && message.length > 0) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: type,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: message,
      });
    }
  }
}
